import { breadcrumbRoutes, IBreadcrumbRoute } from '../../commonComponents/BreadcrumbConfig';

// Generate breadcrumbs based on current path
export const generateBreadcrumbs = (
  pathname: string,
  routes: IBreadcrumbRoute[] = breadcrumbRoutes
): IBreadcrumbRoute[] => {
  const currentRoute = routes.find((route) => route.path === pathname);

  if (currentRoute) {
    const chain = [currentRoute];
    let route = currentRoute;

    while (route.parent) {
      const parentRoute = routes.find((r) => r.path === route.parent);
      if (parentRoute) {
        chain.unshift(parentRoute);
        route = parentRoute;
      } else {
        break;
      }
    }

    return chain;
  }

  // Fallback: build breadcrumbs from path segments
  const pathSegments = pathname.split('/').filter((segment) => segment);
  const breadcrumbs: IBreadcrumbRoute[] = [];

  let currentPath = '';
  for (const segment of pathSegments) {
    currentPath += `/${segment}`;
    const route = routes.find((r) => r.path === currentPath);
    if (route) {
      breadcrumbs.push(route);
    }
  }

  return breadcrumbs;
};

export const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) {
    return 'Good Morning';
  } else if (hour < 18) {
    return 'Good Afternoon';
  } else {
    return 'Good Evening';
  }
};

export const getInitials = (name: string): string => {
  const nameParts = name.split(' ');
  const initials = nameParts[0].charAt(0);
  return initials.toUpperCase();
};
